export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4">PLAY PLACE</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              승부보다 머무는 시간이 즐거운 공간
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">회사 정보</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>사업자: 291-23-02409</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">연락처</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                whwnsdn990@gmail.com
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                평일 10:00 - 18:00
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">주소</h4>
            <p className="text-sm text-gray-400 leading-relaxed">
              서울특별시 강남구 테헤란로 70길 12, 402호
            </p>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2026 PLAY PLACE. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                이용약관
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                개인정보처리방침
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
